export default __webpack_public_path__ + "static/media/fusion-006.b440b66a.svg";